import React from 'react';

type ChipStatus = 'Generating' | 'Promoting' | 'Generated' | 'Not_Generated' | 'Not Generated' | 'Promoted';

type TChipStatusProps = {
    status: string;
}

type ChipStyle = {
    bg: string;
    text: string;
}

const chipStyles: Record<ChipStatus, ChipStyle> = {
    'Generating': { bg: '#FFF8DB', text: '#DE7900' },
    'Promoting': { bg: '#FFF8DB', text: '#DE7900' },
    'Generated': { bg: '#DBEAFF', text: '#0059DE' },
    'Not_Generated': { bg: '#DADBDD', text: '#5C5F62' },
    'Not Generated': { bg: '#DADBDD', text: '#5C5F62' },
    'Promoted': { bg: '#CFFFCE', text: '#11980C' },
};

const defaultStyle: ChipStyle = { bg: '#E9E9EF', text: '#5C5F62' };

const RecomendStatus: React.FC<TChipStatusProps> = ({ status }) => {
    const normalizedStatus = status.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    
    const style = normalizedStatus in chipStyles 
        ? chipStyles[normalizedStatus as ChipStatus] 
        : defaultStyle;

    return (
        <div 
            style={{ backgroundColor: style.bg }} 
            className="tw-px-2 tw-py-1 tw-rounded-[3px] tw-justify-start tw-items-center tw-gap-1 tw-inline-flex"
        >
            <label 
                style={{ color: style.text }} 
                className="tw-text-xs"
            >
                {status}
            </label>
        </div>
    );
}

export default RecomendStatus;